import {l} from "types/typescriptdefinisjoner_lederplan";
import {RessursFeilhåndtering} from "../RessursFeilhåndtering";
import {gettextCatalog} from "angular-gettext";
import {regNavn} from "../tredjepartsTjenestenavn";
import {Kontekst} from "../Kontekst";
import {Debugger} from "debug";
import {IPromise, IQService} from "angular";
import _ from "lodash";

const debug: Debugger = require('debug')('SkjemalåsRessurs');

export class SkjemalåsRessurs {

    static regNavn = 'SkjemalåsRessurs';

    static forInjisering() {
        return [
            "$resource",
            Kontekst.regNavn,
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            regNavn.ng.$q,
            SkjemalåsRessurs]
    }

    private ressurs: ng.resource.IResourceClass<any>;

    constructor($resource: ng.resource.IResourceService, private kontekst: Kontekst, private ressursFeilhåndtering: RessursFeilhåndtering, private gettextCatalog: gettextCatalog, private $q: IQService) {
        this.ressurs = $resource<any>('/api/skjemalaas', {}, {
            finn: {method: 'GET', url: '/api/skjemalaas/finn', isArray: true},
            opprett: {method: 'PUT', url: '/api/skjemalaas/opprett'},
            oppdater: {method: 'POST', url: '/api/skjemalaas/oppdater'},
            frigi: {method: 'DELETE', url: '/api/skjemalaas/frigi'}
        });
    }

    //offentlige metoder

    finn(gruppeId: string, rotentitetId: string, skjemaId: l.SkjemalåsSkjemaId): IPromise<l.SkjemalåsModell[]> {
        debug('finn', gruppeId, rotentitetId, skjemaId)
        return this.ressurs['finn'](
            {gruppeId: gruppeId, rotentitetId: rotentitetId, skjemaId: skjemaId},
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke finne eksisterende skjemalåser'))
        ).$promise;
    }

    opprettSkjemalås(spesifikasjon: l.OpprettSkjemalåsSpesifikasjon): l.OpprettSkjemalåsResponsModell {
        debug('opprettSkjemalås', spesifikasjon)
        return this.ressurs['opprett'](
            spesifikasjon,
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke opprette skjemalås'))
        );
    }

    oppdaterSkjemalås(spesifikasjon: l.OppdaterSkjemalåsSpesifikasjon): l.OppdaterSkjemalåsResponsModell {
        debug('oppdaterSkjemalås', spesifikasjon)
        return this.ressurs['oppdater'](
            spesifikasjon,
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke oppdatere skjemalås'))
        );
    }

    frigiSkjemalås(id: string, klientId: string): l.OkRespons {
        debug('frigiSkjemalås', id)
        return this.ressurs["frigi"](
            {id: id, klientId: klientId},
            _.noop,
            this.håndterFeil(() => this.gettextCatalog.getString('Kunne ikke frigi skjemalås'))
        );
    }

    private håndterFeil(melding: () => string) {
        return this.ressursFeilhåndtering.håndterRequestFeil(melding);
    }
}


